import { BrandMark } from "@/components/BrandMark";
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/Primitives";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [valid, setValid] = useState(null);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/auth/reset-password/validate", { params: { token } }).then(() => setValid(true)).catch((e) => { setValid(false); setErr(errMsg(e)); }); }, [token]);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw.length < 8) return setErr("Password minimal 8 karakter");
    if (pw !== pw2) return setErr("Konfirmasi password tidak sama");
    setLoading(true);
    try { await api.post("/auth/reset-password", { token, password: pw }); toast.success("Password berhasil diubah. Silakan login."); navigate("/login"); } catch (ex) { setErr(errMsg(ex)); } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-sm rise" data-testid="reset-password-page">
        <div className="flex items-center gap-3 mb-10"><BrandMark className="h-10 w-10" textClass="text-xl" /><span className="font-heading font-semibold text-lg">Yutaka CRM <span className="text-xs italic text-primary font-normal">— Grow Together be Stronger</span></span></div>
        <p className="eyebrow mb-2">Reset Password</p>
        <h2 className="font-heading text-2xl font-semibold mb-8">Buat password baru</h2>
        {valid === null ? <p className="text-sm text-muted-foreground">Memeriksa tautan...</p> : valid === false ? (
          <div data-testid="reset-invalid" className="surface p-6"><p className="text-sm text-destructive">{err}</p><Button asChild variant="outline" className="mt-4" data-testid="reset-request-new"><Link to="/forgot-password">Minta tautan baru</Link></Button></div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Field label="Password baru" hint="Minimal 8 karakter"><Input data-testid="reset-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required /></Field>
            <Field label="Ulangi password"><Input data-testid="reset-password-confirm-input" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required /></Field>
            {err && <p data-testid="reset-error" className="text-sm text-destructive bg-destructive/10 rounded-lg px-3 py-2">{err}</p>}
            <Button data-testid="reset-submit-button" type="submit" className="w-full h-11" disabled={loading}>{loading ? "Menyimpan..." : "Simpan Password Baru"}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
